module.exports = __webpack_public_path__ + "img/area-part3-541.5cd8d192.png";